import AdhocReporting from './AdhocReporting';

export default AdhocReporting;
